import { Outlet } from "react-router-dom";
import "./AuthLayout.css";

export default function AuthLayout() {
  return (
    <main className="auth-layout">
      {/* Decorative background elements */}
      <div className="auth-layout__bg-blobs" aria-hidden="true">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      <section className="auth-layout__brand">
        <div className="brand-container">
          <span className="auth-layout__badge">TOPunt Gent</span>
          <h1 className="brand-title">
            POWER <br />
            <span>Registratie Systeem</span>
          </h1>
          <p className="brand-description">
            Beveiligde toegang voor coaches en medewerkers binnen het
            <strong> POWER traject</strong>.
          </p>
        </div>
      </section>

      <section className="auth-layout__content">
        <div className="auth-card-wrapper">
          <Outlet />
        </div>
      </section>
    </main>
  );
}
